import React, { useContext, useState } from 'react'
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import SidePanelAssistants from './SidePanelAssistants'
import SidePanelDocuments from './SidePanelDocuments'
import SidePanelGeneralCommitments from './SidePanelGeneralCommitments'
import { useGetBasicRevisionInformation } from '../../../../../../hooks/services/sKPI/useOfGAP';
import SidePanelGeneralComments from './SidePanelGeneralComments';
import ToolBarDownFall from '../../../../sBook/ToolbarDownFall';
import SidePanelViewRevisionEvents from './SidePanelViewRevisionEvents';
import MainAppContext from '../../../../../../MainAppContext';
import GapAppContext from '../../../../../../GapAppContext';
import { __enum_PageMode, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import SidePanelAddRevision from '../../../DialogGenerateGap/SidePanelAddRevision';
import SidePanelGapDataserieComments from './SidePanelGapDataserieComments';

function GapRevisionInfoTool(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);

    const {
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_GapSelectedRevisionId = null,
        inputParam_GapElementId = null,
        inputParam_SetFireGetLastActions = null,
    } = props;

    const [isEditRevisionPanelOpen, setIsEditRevisionPanelOpen] = useState(false);
    const [isAssistantsPanelOpen, setIsAssistantsPanelOpen] = useState(false);
    const [isDocuemntsPanelOpen, setIsDocumentsPanelOpen] = useState(false);
    const [isGeneralCommitmentsPanelOpen, setIsGeneralCommitmentsPanelOpen] = useState(false);
    const [isGeneralCommentsPanelOpen, setIsGeneralCommentsPanelOpen] = useState(false);
    const [isRevisionEventsPanelOpen, setIsRevisionEventsPanelOpen] = useState(false);
    const [isDataserieCommentsPanelOpen, setIsDataserieCommentsPanelOpen] = useState(false);

    

    const _priv_canManageRevPerfDialogue = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)
    const _priv_canManageRevPerfDialogueElementId = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, inputParam_GapElementId, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE)

    const [revisionBasicInformation, setRevisionBasicInformation] = useState(null);
    useGetBasicRevisionInformation(inputParam_GapAnalyzeId, inputParam_GapRevisionId, revisionBasicInformation, setRevisionBasicInformation, true, false)

    const onEditRevisionClick = () => {
        setIsEditRevisionPanelOpen(true)
    }

    const onSelectAssistantsListClick = () => {
        setIsAssistantsPanelOpen(true)
    }

    const onRevisionEventsListClick = () => {
        setIsRevisionEventsPanelOpen(true)
    }

    const onSelectBackupDocumentsClick = () => {
        setIsDocumentsPanelOpen(true)
    }

    const onSelectGeneralCommitmentsClick = () => {
        setIsGeneralCommitmentsPanelOpen(true)
    }

    const onSelectGeneralCommentsClick = () => {
        setIsGeneralCommentsPanelOpen(true)
    }

    const onSelectRevisionDataserieCommentsClick = () => {
        setIsDataserieCommentsPanelOpen(true)
    }
    
    const toolBarItems_Revision = {
        items: [
            {
                key: 'assistantslist',
                text: t('data-lang-lbl-assistantslist'),
                iconProps: { iconName: revisionBasicInformation !== null ? (revisionBasicInformation.listAssistants ? 'People' : 'PeopleAdd') : 'PeopleAdd' },
                onClick: onSelectAssistantsListClick,
            },{
                key: 'backupdocuments',
                text: t('data-lang-lbl-backupdocuments'),
                iconProps: { iconName: revisionBasicInformation !== null ? (revisionBasicInformation.backupDocs ? 'TextDocument' : 'PageAdd') : 'PageAdd' },
                onClick: onSelectBackupDocumentsClick,
            },{
                key: 'generalcomments',
                text: t('data-lang-lbl-generalcomments'),
                iconProps: { iconName: revisionBasicInformation !== null ? (revisionBasicInformation.generalComments ? 'Comment' : 'CommentAdd') : 'CommentAdd' },
                disabled: inputParam_GapElementId === null ? true : false,
                onClick: inputParam_GapElementId !== null ? onSelectGeneralCommentsClick : null,
            },{
                key: 'generalcommitments',
                text: t('data-lang-lbl-generalcommitments'),
                iconProps: { iconName: 'AddEvent' },
                onClick: onSelectGeneralCommitmentsClick,
            },{
                key: 'revisiondatasetiecomments',
                text: t('data-lang-lbl-revisiondatasetiecomments'),
                iconProps: { iconName: 'FileComment' },
                onClick: onSelectRevisionDataserieCommentsClick,
            },
            {
                key: 'viewlastevents',
                text: t('data-lang-lbl-lastevents'),
                iconProps: { iconName: 'Calendar' },
                onClick: onRevisionEventsListClick,
            },{
                key: 'editrevision',
                text: t('data-lang-lbl-editrevision'),
                iconProps: { iconName: 'Edit' },
                onClick: onEditRevisionClick,
            }
        ].filter(x =>_priv_canManageRevPerfDialogueElementId.value && _priv_canManageRevPerfDialogueElementId.mode === __enum_PageMode.Edit ? true :  (x.key !== "editrevision")),
    };

    return (
        <>
            <ToolBarDownFall items={ toolBarItems_Revision } display={ true } disabled={inputParam_GapSelectedRevisionId !== inputParam_GapRevisionId} mainItem={ { iconName: 'More' } } />
            {
                inputParam_GapRevisionId &&
                <>
                    <SidePanelAssistants
                        inputParam_EditMode={_priv_canManageRevPerfDialogue.value ? _priv_canManageRevPerfDialogue.mode === __enum_PageMode.Edit : false}
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_GapRevisionId={inputParam_GapRevisionId}
                        inputParam_IsPanelOpen={isAssistantsPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsAssistantsPanelOpen}
                        inputParam_SetterChangedEntityProps={setRevisionBasicInformation}
                    />
                    {
                        isGeneralCommentsPanelOpen &&
                        <SidePanelGeneralComments
                            inputParam_EditMode={_priv_canManageRevPerfDialogue.value ? _priv_canManageRevPerfDialogue.mode === __enum_PageMode.Edit : false}
                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                            inputParam_GapRevisionId={inputParam_GapRevisionId}
                            inputParam_IsPanelOpen={isGeneralCommentsPanelOpen}
                            inputParam_SetterIsPanelOpen={setIsGeneralCommentsPanelOpen}
                            inputParam_SetterChangedEntityProps={setRevisionBasicInformation}
                        />
                    }
                    {
                        isDataserieCommentsPanelOpen &&
                        <SidePanelGapDataserieComments
                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                            inputParam_RevisionId={inputParam_GapRevisionId}
                            inputParam_IsPanelOpen= {isDataserieCommentsPanelOpen}
                            inputParam_SetterIsPanelOpen={setIsDataserieCommentsPanelOpen}
                        />
                    }
                    {
                        inputParam_GapElementId &&
                        <SidePanelGeneralCommitments
                            inputParam_EditMode={_priv_canManageRevPerfDialogueElementId.value ? _priv_canManageRevPerfDialogueElementId.mode === __enum_PageMode.Edit : false}
                            inputParam_GapRevisionId={inputParam_GapRevisionId} 
                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId} 
                            inputParam_GapElementId={inputParam_GapElementId}    
                            inputParam_IsPanelOpen={isGeneralCommitmentsPanelOpen}
                            inputParam_SetterIsPanelOpen={setIsGeneralCommitmentsPanelOpen}
                            inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}
                        />
                    }
                    
                    <SidePanelDocuments
                        editMode={_priv_canManageRevPerfDialogue.value ? _priv_canManageRevPerfDialogue.mode === __enum_PageMode.Edit : false}
                        isPanelOpen={isDocuemntsPanelOpen}
                        setterIsPanelOpen={setIsDocumentsPanelOpen}
                        gapRevisionId={inputParam_GapRevisionId}         
                    />
                    <SidePanelViewRevisionEvents
                        inputParam_IsPanelOpen={isRevisionEventsPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsRevisionEventsPanelOpen}
                        inputParam_GapRevisionId={inputParam_GapRevisionId}         
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                    /> 
                    <SidePanelAddRevision 
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_GapElementId={inputParam_GapElementId}
                        inputParam_IsPanelOpen={isEditRevisionPanelOpen}
                        inputParam_SetterIsPanelOpen={setIsEditRevisionPanelOpen}
                        inputParam_EditMode={true}
                        inputParam_GapRevisionId={inputParam_GapRevisionId}
                        inputParam_SetRevisionList={null}
                        inputParam_RevisionList={null}
                    />
                </>
            }
        </>
    );
}

GapRevisionInfoTool.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number,
    inputParam_GapSelectedRevisionId: PropTypes.number,
    inputParam_GapElementId: PropTypes.number,
};

export default GapRevisionInfoTool;